import styled from "styled-components";
import { colorVariables } from "../styles/variables";
import InfoImg from "../assets/info.png";

export const InformationIconContainer = styled.div`
  width: 51px;
  height: 51px;
  background-color: var(--button);/* $ {colorVariables.lightGrey1}; */
  border-radius: 50%;
  margin-right: 71px;
  margin-top: ${props => props.marginTop ?? "40px"};

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const InformationIcon = styled.img`
  width: 33px;
  height: 33px;
  cursor: pointer;
  filter: brightness(0) saturate(100%) invert(100%) sepia(60%) saturate(0%)
    hue-rotate(38deg) brightness(101%) contrast(105%);
`;

const Information = ({ handleClick, open, marginTop }) => {
  return (
    <InformationIconContainer marginTop={marginTop} onClick={() => {
      handleClick(!open);
    }}>
        <InformationIcon src={InfoImg}></InformationIcon>
    </InformationIconContainer>
  );
};

export default Information;
